export const getZIndex = (item) => {
    return item.style.zIndex ? Number.parseInt(item.style.zIndex) : 0;
};
export const adjustZIndex = (item, adjustment) => {
    item.style.zIndex = (getZIndex(item) + adjustment).toString();
};
